<div class="rotate-popup">
    <div class="rotate-popup__text">
        Please rotate your device to landscape for better experience
    </div>
    <img class="rotate-popup__icon" src="../../../assets/images/rotate-icon-light.png" alt="">
</div>
